//The Dialog that shows when any "PICTURES" button gets clicked on the sites page.
//Two things are different depending which button gets clicked - the dialog title and the dialog pictures

//mui and react imports
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";

//there are 6 props: open, setDialogIsOpen, title, pics, currentSitePictureIndex and setCurrentSitePictureIndex
export const SitePicsDialog = (props) => {
  //the actual component
  return (
    <Dialog open={props.open} onClose={() => props.setDialogIsOpen(false)}>
      <DialogTitle sx={{ paddingBottom: 0 }}>{props.title}</DialogTitle>
      <DialogTitle sx={{ paddingTop: 0, paddingBottom: 1 }}>
        {props.pics.length <= props.currentSitePictureIndex
              ? props.pics[0].display_name
              : props.pics[props.currentSitePictureIndex].display_name}
      </DialogTitle>

      <DialogContent>
        <img
          src={
            props.pics.length <= props.currentSitePictureIndex
              ? props.pics[0].location
              : props.pics[props.currentSitePictureIndex].location
          }
          //   src={props.pics[props.currentSitePictureIndex].location}
          style={{ maxWidth: "100%", maxHeight: "calc(100vh) - 64px" }}
          alt="campsite"
        />
      </DialogContent>
      {/* justifyContent spaceBetween puts the "previous" button on the left */}
      <DialogActions style={{ justifyContent: "space-between" }}>
        <IconButton
          sx={{
            position: "absolute",
            left: "91%",
            top: "2%",
            backgroundColor: "lightgray",
            color: "gray",
          }}
          onClick={() => props.setDialogIsOpen(false)}
        >
          <CloseIcon />
        </IconButton>
        <Button
          disabled={props.currentSitePictureIndex === 0}
          onClick={() => {
            props.setCurrentSitePictureIndex(props.currentSitePictureIndex - 1);
          }}
        >
          Previous
        </Button>
        <Button
          disabled={props.currentSitePictureIndex === props.pics.length - 1}
          onClick={() => {
            props.setCurrentSitePictureIndex(props.currentSitePictureIndex + 1);
          }}
        >
          Next
        </Button>
      </DialogActions>
    </Dialog>
  );
};
